import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import axiosApi from "helpers/api_helper"
import handleApiError from "../../../components/authGuard"

export const getSubscription = createAsyncThunk(
    'abonnement/get',
    async (_, { rejectWithValue }) => {
        try {
            const response = await axiosApi.get(
                'player/abonnement',
                {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem('auth_token')}`
                    }
                }
            );
            return response.data;
        } catch (error) {
            const message = handleApiError(error);
            return rejectWithValue(message);
        }
    }
);

const subscriptionSlice = createSlice({
    name: "subscription",
    initialState: {
        error: null,
        success: null,
        loading: null,
        subscription: {},

    },
    extraReducers: (builder) => {
        builder
            .addCase(getSubscription.pending, (state) => {
                state.success = null
                state.error = null
                state.loading = true
            })
            .addCase(getSubscription.fulfilled, (state, action) => {
                state.subscription = action.payload
                state.loading = false
                state.success = true
            })
            .addCase(getSubscription.rejected, (state, action) => {
                state.error = action.payload
                state.loading = false
                state.success = false
            })


    },
})


export default subscriptionSlice.reducer
